import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Props } from './props';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { AnchorContext } from '../../context/anchor';
import { Tooltip } from 'antd';

const AnchorButton: React.FC<Props> = ({ textRoute }) => {
  const { setactiveKey } = useContext(AnchorContext);
  setactiveKey(textRoute);

  return (
    <Tooltip placement="topLeft" title={'Precisa de ajuda com o Portal Kothe Log? Clique aqui!.'}>
      <Link to={`/dashboard/ajuda/${textRoute}`}>
        <QuestionCircleOutlined
          style={{ fontSize: '18px', paddingRight: '5px', color: '#00b1f1' }}
        />
      </Link>
    </Tooltip>
  );
};

export default AnchorButton;
